<template>
  <el-dialog
    :visible.sync="visible"
    width="80%"
    v-if="validation"
    class="field-validation-form"
  >
    <el-form
      :model="validation"
      ref="form"
      label-width="140px"
    >
      <el-form-item label="Validation" prop="key">
        <el-select
          v-model="validation.key"
          placeholder="Please select one option"
          :rules="[
            {
              required: true,
              message: 'Validation is required',
              trigger: 'blur',
            },
          ]"
        >
          <el-option
            v-for="key in enabledKeys"
            :key="key"
            :label="label(field, key)"
            :value="key"
          ></el-option>
        </el-select>

        <div
          class="leading-7 text-xs font-medium text-gray-500"
          v-if="help(field, validation.key)"
        >
          {{ help(field, validation.key) }}
        </div>
      </el-form-item>

      <el-form-item
        v-if="
          validation.key &&
            htmlField(field, validation.key) === 'text'
        "
        label="Value"
        prop="value"
        :rules="[
          {
            required: true,
            message: 'Value is required',
            trigger: 'blur',
          },
        ]"
      >
        <el-input v-model="validation.value"></el-input>
      </el-form-item>

      <el-form-item
        v-if="
          validation.key &&
            htmlField(field, validation.key) === 'select'
        "
        label="Value"
        prop="value"
        :rules="[
          {
            required: true,
            message: 'Value is required',
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="validation.value"
          placeholder="Please select one option"
        >
          <el-option
            v-if="!required(field, validation.key)"
            label="Please select one option"
            value
          />
          <el-option
            v-for="choice in choices(field, validation.key)"
            :key="choice.value"
            :label="choice.label"
            :value="choice.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="
          validation.key &&
            htmlField(field, validation.key) === 'number'
        "
        label="Value"
        prop="value"
        :rules="[
          {
            type: 'number',
            required: true,
            message: 'Value is required',
            trigger: 'blur',
          },
        ]"
      >
        <el-input-number
          v-model.number="validation.value"
        ></el-input-number>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="save()"
        >Save</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-field-validation-form',

  mounted() {
    if (
      this.$refs.tooltip1 &&
      this.$refs.tooltip1.referenceElm
    ) {
      this.$refs.tooltip1.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
  },

  computed: {
    ...mapGetters({
      properties: 'builder/propertyCurrent/current',
      entity: 'builder/entityCurrent/current',
      field: 'builder/fieldCurrent/current',
      validation: 'builder/fieldValidationCurrent/current',
      keys: 'builder/fieldValidation/keys',
      htmlField: 'builder/fieldValidation/htmlField',
      choices: 'builder/fieldValidation/choices',
      enabled: 'builder/fieldValidation/enabled',
      required: 'builder/fieldValidation/required',
      help: 'builder/fieldValidation/help',
      label: 'builder/fieldValidation/label',
    }),

    enabledKeys() {
      const enableds = (key) =>
        this.enabled(
          this.properties,
          this.entity,
          this.field,
          key,
        );
      return this.keys(this.field).filter(enableds);
    },

    visible: {
      get() {
        return !!this.validation;
      },

      set(value) {
        if (!value) {
          this.$store.commit(
            'builder/fieldValidationCurrent/clear',
          );
        }
      },
    },
  },

  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.dispatch(
            'builder/fieldValidationCurrent/persist',
          );
        }
      });
    },
  },
};
</script>
